var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFactor4X(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 35,
    viewBox: "0 0 34 35",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 17,
    cy: 17.9099,
    r: 16.5,
    fill: "#94A3B8",
    stroke: "#94A3B8"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.4874 18.0539L14.1514 15.4939H16.6154L13.7354 19.5419C14.3754 20.3419 14.9568 21.1206 15.4794 21.8779C16.0021 22.6352 16.4181 23.3126 16.7274 23.9099H14.1674C14.0821 23.7499 13.9754 23.5526 13.8474 23.3179C13.7194 23.0726 13.5754 22.8219 13.4154 22.5659C13.2554 22.2992 13.0848 22.0379 12.9034 21.7819C12.7328 21.5152 12.5621 21.2752 12.3914 21.0619C12.2314 21.2646 12.0661 21.4886 11.8954 21.7339C11.7354 21.9792 11.5808 22.2299 11.4314 22.4859C11.2821 22.7312 11.1328 22.9766 10.9834 23.2219C10.8448 23.4672 10.7221 23.6966 10.6154 23.9099H8.18344C8.31144 23.6432 8.48744 23.3286 8.71144 22.9659C8.93544 22.6032 9.17544 22.2299 9.43144 21.8459C9.69811 21.4512 9.97544 21.0619 10.2634 20.6779C10.5514 20.2832 10.8341 19.9152 11.1114 19.5739C10.6314 18.9019 10.1514 18.2246 9.67144 17.5419C9.19144 16.8486 8.71677 16.1659 8.24744 15.4939H10.8234L12.4874 18.0539ZM21.9868 15.7339C21.5708 16.2779 21.1281 16.8699 20.6588 17.5099C20.1895 18.1499 19.7948 18.8059 19.4748 19.4779H21.9868V15.7339ZM24.3228 12.8219V19.4779H25.5068V21.4299H24.3228V23.9099H21.9868V21.4299H17.2028V19.6859C17.4375 19.2166 17.7308 18.6886 18.0828 18.1019C18.4348 17.5046 18.8241 16.8966 19.2508 16.2779C19.6881 15.6486 20.1468 15.0352 20.6268 14.4379C21.1068 13.8406 21.5868 13.3019 22.0668 12.8219H24.3228Z",
    fill: "#2D3344"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFactor4X);
export default __webpack_public_path__ + "static/media/factor4x.ac2b779e36dc7d59bff78879ab61122c.svg";
export { ForwardRef as ReactComponent };